module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "s-popup",
    on: {
      "click": function($event) {
        return _vm.wrapperClose($event)
      }
    }
  }, [_c('div', {
    staticClass: "s-popup-wrapper"
  }, [_c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasHeader),
      expression: "hasHeader"
    }],
    staticClass: "s-popup-header clearfix"
  }, [_c('h4', {
    staticClass: "fl"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasClose),
      expression: "hasClose"
    }],
    staticClass: "fr s-popup-close",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._m(0)])]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasBody),
      expression: "hasBody"
    }],
    staticClass: "s-popup-body"
  }, [_vm._t("popup-body")], 2), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasFooter),
      expression: "hasFooter"
    }],
    staticClass: "s-popup-footer"
  }, [_vm._t("popup-footer")], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('img', {
    attrs: {
      "src": require("../images/common/close.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-17fdbd60!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/popup.vue
// module id = ObVG
// module chunks = 15